var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("svg-icon", { attrs: { name: "nodata" } }),
      _c("p", [_vm._v(_vm._s(_vm.message))]),
      _c(
        "div",
        { staticClass: "page-button" },
        [
          _c("el-button", { attrs: { size: "mini" } }, [
            _vm._v(
              _vm._s(_vm.$t("components.promptInformation.previouPage")) +
                "(" +
                _vm._s(_vm.countDown) +
                "s) "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.goHome()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("components.promptInformation.backHome")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }